import { NotificationsService } from '../../../../shared/modules/notifications/notifications.service';
import { IApiAddSettingsInput, IApiSettings, IApiUpdateSettingsInput } from '../../../../shared/modules/graphql/types/types';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { NgForm } from '@angular/forms';
import { SettingsService } from 'src/app/shared/services';
import { LoaderService } from 'src/app/shared/modules/loader/loader.service';

@Component({
  selector: 'app-settings-modal',
  templateUrl: './settings-modal.component.html',
  styleUrls: ['./settings-modal.component.scss']
})
export class SettingsModalComponent extends DialogContentBase implements OnInit {
  public model: IApiAddSettingsInput | IApiUpdateSettingsInput;
  public isValidForm: boolean = false;
  @Input() data: IApiSettings;
  @ViewChild('form', { static: false }) form: NgForm;
  constructor(
    private settingsService: SettingsService,
    private notifications: NotificationsService,
    private loaderService: LoaderService,
    public dialogRef: DialogRef
  ) {
    super(dialogRef);
  }

  ngOnInit(): void {
    const {
      id,
      key = "",
    } = this.data || {};
    const value = key === 'SAGE_TAXABLE_STATES' && this.data?.value && JSON.parse(this.data?.value)?.length ? JSON.parse(this.data?.value) : this.data?.value
    this.model = {
      id,
      key,
      value
    };
    this.checkFormValidity();
  }
  onSubmit() {
    if (!this.isValidForm) {
      this.form.form.markAllAsTouched();
      return;
    };
    const { id = null } = this.data || {};
    if (id) this.save();
    else this.add();
  }

  public close(action = false) {
    return this.dialogRef.close(action);
  }

  public prepareObject(value) {
    return Array.isArray(value) ? JSON.stringify(value) : value?.trim();
  }

  public save() {
    this.loaderService.show$(this.settingsService.update({
      id: this.data.id,
      key: this.model?.key?.trim(),
      value: this.prepareObject(this.model.value)
    })).pipe(
      this.notifications.snackbarPipe("Setting updated"),
      this.notifications.snackbarErrorPipe("Error updating setting")
    ).subscribe(() => this.close(true));
  }
  public add() {
    this.loaderService.show$(this.settingsService.add(this.model as IApiAddSettingsInput)).pipe(
      this.notifications.snackbarPipe("Setting added"),
      this.notifications.snackbarErrorPipe("Error adding setting")
    ).subscribe(() => this.close(true));
  }

  setStatesSelection(e) {
    this.model.value = e;
    this.checkFormValidity();
  }

  checkFormValidity() {
    if (this.model.key === 'SAGE_TAXABLE_STATES') {
      this.isValidForm = Array.isArray(this.model.value) && this.model.value.length > 0;
    } else {
      this.isValidForm = !!this.model.value && this.model.value.trim() !== '';
    }
  }

}
